import React, { useContext } from 'react'

import { startCase } from 'lodash'
import moment from 'moment'
import { splitEvery } from 'ramda'

import { CircleLoader,Div, H4 } from '@driftt/tide-core'

import Card from 'components/Card'
import { OrgUsersById, OrgUsersContext } from 'context/orgUsersContext'

import styles from './styles.module.css'

const NUM_COLUMNS = 3

interface GroupedAttributesProps {
  headerText: string
  attributes: FieldProps[] | undefined
  emptyStateText: string
  forwardRef?: React.MutableRefObject<any>
  isLoading?: boolean
}

interface FieldProps {
  label: string
  value: any
  type?: string
}

const parseField = (value: any, metadata: any, { orgUsers }: any) => {
  const dateFormatString = 'MM/DD/YYYY'
  const dateTimeFormatString = 'MM/DD/YYYY h:mma'

  switch (metadata.type) {
    case 'DATE':
      return moment(Number(value) || metadata).format(dateFormatString)
    case 'DATETIME':
      return moment(value).format(dateTimeFormatString)
    case 'CURRENCY':
      return value?.toLocaleString('en-us', {
        style: 'currency',
        currency: 'USD'
      })
    case 'NUMBER':
      return value?.toLocaleString()
    case 'TEAMMEMBER':
      return orgUsers[value]?.name
    default:
      return value ? String(value) : undefined
  }
}

const GroupedAttributesCard: React.FC<GroupedAttributesProps> = ({
  headerText,
  attributes,
  emptyStateText,
  forwardRef,
  isLoading
}) => {
  const orgUsersById = useContext<OrgUsersById>(OrgUsersContext)

  const groupedAttributes = attributes && splitEvery(NUM_COLUMNS, attributes)

  return (
    <Card forwardRef={forwardRef} className={styles.attributeCard}>
      <Div className={styles.sectionHeader}>
        <H4>{headerText}</H4>
      </Div>
      {!isLoading && (
        <Div className={styles.attributesContainer}>
          {groupedAttributes && groupedAttributes.length > 0 ? (
            groupedAttributes.map((fields: any, index: number) => (
              <Div className={styles.row} key={index}>
                {fields &&
                  fields.map((field: FieldProps) => (
                    <Div className={styles.column} key={field.label}>
                      <Div className={styles.field}>
                        <Div className={styles.fieldLabel}>{startCase(field.label)}</Div>
                        <Div className={styles.fieldValue}>
                          {parseField(field.value, field, { orgUsers: orgUsersById }) || '-'}
                        </Div>
                      </Div>
                    </Div>
                  ))}
              </Div>
            ))
          ) : (
            <Div className={styles.row}>{emptyStateText}</Div>
          )}
        </Div>
      )}
      {isLoading && (
        <Div className={styles.loadingContainer}>
          <CircleLoader />
        </Div>
      )}
    </Card>
  )
}

export default GroupedAttributesCard
